// extracted by mini-css-extract-plugin
export var bottom = "feature-box-module--bottom--b9918";
export var box = "feature-box-module--box--ae0c8";
export var cont = "feature-box-module--cont--426b2";
export var content = "feature-box-module--content--d441f";
export var copy = "feature-box-module--copy--43bc6";
export var cta = "feature-box-module--cta--a85f6";
export var image = "feature-box-module--image--1fc0d";
export var sfeats = "feature-box-module--sfeats--b3582";
export var sfeats_menu = "feature-box-module--sfeats_menu--f0df2";
export var summary = "feature-box-module--summary--b3201";
export var title = "feature-box-module--title--72c8d";
export var top = "feature-box-module--top--dfee0";